/**
 * @see https://laravel.com/docs/10.x/vite#blade-processing-static-assets
 */
import.meta.glob(["../images/**"]);

import "./utils/axios";

import Tooltip from "@ryangjchandler/alpine-tooltip";
import { Alpine } from "../../vendor/livewire/livewire/dist/livewire.esm";

import clipboard from "./alpine/data/clipboard";
import hovery from "./alpine/data/hovery";
import player from "./alpine/data/player";
import seline from "./alpine/seline";
import sensitive from "./alpine/stores/sensitive";
import modals from "./alpine/stores/modals";

Alpine.plugin(seline);

Alpine.plugin(
    Tooltip.defaultProps({
        animation: "shift-away-subtle",
    }),
);

document.addEventListener("alpine:init", () => {
    Alpine.store("modals", modals());
    Alpine.store("sensitive", sensitive());

    Alpine.data("clipboard", clipboard);
    Alpine.data("player", player);
    Alpine.data("hovery", hovery);
});
